import { PRODUCT_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const useProductListActions = (id: string) => {
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        window.open(`${PRODUCT_EDIT}/${id}`, '_blank');
    };

    return {
        handleEdit,
    };
};
